import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransactionsSeriesListComponent } from './transactions-series-list/transactions-series-list.component';
import { TransactionsSeriesDetailComponent } from './transactions-series-detail/transactions-series-detail.component';

const routes: Routes = [
    {
        path: 'transactionsSeries',
        children: [
            { path: '', component: TransactionsSeriesListComponent }
        ]
    },
    {
        path: 'transactionsSeries/:guid',
        children: [
            { path: '', component: TransactionsSeriesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TransactionsSeriesRoutingModule { }
